import { ScrollView, View } from 'react-native';

import { BILLING_ENABLED } from '@/lib/billing';

import { ContextStrip } from './ContextStrip';
import { Features } from './Features';
import { FinalCta } from './FinalCta';
import { Hero } from './Hero';
import { LandingFooter } from './LandingFooter';
import { LandingNav } from './LandingNav';
import { Pricing } from './Pricing';
import { Showcase } from './Showcase';

/**
 * Web-only signed-out marketing homepage. Reimplements the "Landing" design
 * export with the Field Manual UI library + Uniwind tokens. The mobile signed-out
 * screen stays in `app/landing.tsx` (the bare fallback, which also serves native);
 * this overrides it on web via `landing.web.tsx`.
 *
 * Color note: every color used by the typography helpers (Display/Heading/Body/…)
 * is a global.css token applied via `variant="none"` rather than overriding a
 * shared <Text> variant — `cn()` does not merge conflicting utilities, so a color
 * class layered over a variant's own color wins or loses by stylesheet order, not
 * call order. A single color class (no variant default) is always deterministic.
 */

const SIGN_UP = '/sign-up';
const SIGN_IN = '/sign-in';

export function WebLanding() {
  return (
    <View className="flex-1 bg-background">
      <LandingNav signInHref={SIGN_IN} getStartedHref={SIGN_UP} />

      <ScrollView className="flex-1" showsVerticalScrollIndicator={false}>
        <Hero getStartedHref={SIGN_UP} />
        <ContextStrip />
        <Features />
        <Showcase />
        {BILLING_ENABLED ? <Pricing getStartedHref={SIGN_UP} /> : null}
        <FinalCta getStartedHref={SIGN_UP} />
        <LandingFooter />
      </ScrollView>
    </View>
  );
}
